var base = require('kiosk/add-discount');

Vue.component('spark-kiosk-add-discount', {
    mixins: [base],

    data() {
    	return {
    		discountDialogVisible: false
    	}
    },

    created() {
		Bus.$on('addDiscount', this.showDiscountDialog);
    },

    methods: {
    	closeDiscountDialog() {
			this.discountDialogVisible = false;
    	},

        showDiscountDialog() {
        	this.discountDialogVisible = true;
        },

        // Override discount to close modal
        applyDiscount() {
            Spark.post('/spark/kiosk/users/discount/' + this.discountingUser.id, this.form)
                .then(() => {
                    this.closeDiscountDialog();
                });
        }
    }
});
